import type { TagItem } from '@/components/common/FormExpandableSection/FormExpandableSection';

export function getContentCategoryTags(isIABEnabled: boolean, isIASEnabled: boolean): TagItem[] {
  const result: TagItem[] = [];
  if (isIABEnabled) {
    result.push({ label: 'IAB' });
  }
  if (isIASEnabled) {
    result.push({ label: 'IAS' });
  }

  return result;
}
